import React from 'react';
import { MessageSquare, Phone, MapPin, Mail, Award } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function ContactUs() {
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-506">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-507">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-508">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-509">Contact Us</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-510">
            Our local support team is here to answer your questions about
            classes, requirements, or technical issues.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-511">
          {/* Left Column - Contact Form */}
          <Card className="p-6 lg:p-8" data-id="element-512">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-513">
              Send Us An Email Message
            </h2>

            <form className="space-y-4" data-id="element-514">
              {/* Name */}
              <div data-id="element-515">
                <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-516">
                  Name<span className="text-red-500" data-id="element-517">*</span>
                </label>
                <input type="text" id="name" name="name" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-518" />
              </div>

              {/* Company Name */}
              <div data-id="element-519">
                <label htmlFor="company" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-520">
                  Company Name
                </label>
                <input type="text" id="company" name="company" className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-521" />
              </div>

              {/* E-mail */}
              <div data-id="element-522">
                <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-523">
                  E-mail<span className="text-red-500" data-id="element-524">*</span>
                </label>
                <input type="email" id="email" name="email" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-525" />
              </div>

              {/* Phone */}
              <div data-id="element-526">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-527">
                  Phone<span className="text-red-500" data-id="element-528">*</span>
                </label>
                <input type="tel" id="phone" name="phone" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-529" />
              </div>

              {/* Subject */}
              <div data-id="element-530">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-531">
                  Subject<span className="text-red-500" data-id="element-532">*</span>
                </label>
                <input type="text" id="subject" name="subject" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-533" />
              </div>

              {/* Message */}
              <div data-id="element-534">
                <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-535">
                  Message<span className="text-red-500" data-id="element-536">*</span>
                </label>
                <textarea id="message" name="message" rows={4} required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm resize-none" data-id="element-537" />
              </div>

              {/* reCAPTCHA Placeholder */}
              <div className="bg-gray-100 border border-gray-300 rounded-md p-3 flex items-center" data-id="element-538">
                <input type="checkbox" id="recaptcha" className="h-5 w-5 text-brand-purple-600 focus:ring-brand-purple-500 border-gray-300 rounded mr-2" data-id="element-539" />
                <label htmlFor="recaptcha" className="text-xs text-gray-700" data-id="element-540">
                  I'm not a robot
                </label>
                <div className="ml-auto text-right" data-id="element-541">
                  <div className="text-xs text-gray-500 font-medium" data-id="element-542">
                    reCAPTCHA
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-543">Privacy - Terms</div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="w-full px-6 py-3 bg-brand-orange-400 text-brand-purple-900 font-bold rounded-md hover:bg-brand-orange-500 transition-colors shadow-md" data-id="element-544">
                Send Message
              </button>
            </form>

            <p className="mt-4 text-center text-sm text-gray-600" data-id="element-545">
              We typically respond within 24 hours during business days
            </p>
          </Card>

          {/* Right Column - Contact Information */}
          <div className="space-y-6" data-id="element-546">
            {/* Need Help Section */}
            <div className="p-6 bg-gradient-to-br from-brand-purple-600 to-brand-purple-700 text-white rounded-xl shadow-sm" data-id="element-547">
              <h2 className="text-2xl font-bold mb-4" data-id="element-548">Need Help?</h2>
              <p className="text-brand-purple-100 mb-6" data-id="element-549">
                Our local support team is here to answer your questions about
                classes, requirements, or technical issues.
              </p>
              <a href="tel:602-377-6207" className="inline-flex items-center justify-center w-full bg-white text-brand-purple-900 px-6 py-3 rounded-full font-bold text-lg hover:bg-brand-orange-400 transition-colors shadow-lg" data-id="element-550">
                <Phone className="w-5 h-5 mr-2" data-id="element-551" />
                602-377-6207
              </a>
              <p className="text-center text-brand-purple-100 text-sm mt-3 font-medium" data-id="element-552">
                Call, Text, Chat or Email us
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}